


// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import {
//   Box,
//   Typography,
//   Button,
//   TextField,
//   Container,
//   Paper,
//   useMediaQuery,
//   useTheme,
//   List,
//   ListItem,
//   ListItemText,
//   Popper,
//   Grow,
//   ClickAwayListener,
//   MenuItem,
//   Select,
//   FormControl,
//   FormHelperText,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
// } from '@mui/material';
// import PostAccess from './PostAccess';

// const AddNewProperty = () => {
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//   // State management
//   const [propertyType, setPropertyType] = useState(() => {
//     return localStorage.getItem('propertyType') || '';
//   });

//   const [category, setCategory] = useState(() => {
//     return localStorage.getItem('category') || '';
//   });

//   const [location, setLocation] = useState(() => {
//     return localStorage.getItem('propertyLocation') || '';
//   });

//   // Continue dialog state
//   const [continueDialog, setContinueDialog] = useState(false);

//   // City suggestions
//   const [citySuggestions, setCitySuggestions] = useState([]);
//   const [showSuggestions, setShowSuggestions] = useState(false);
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [debounceTimer, setDebounceTimer] = useState(null);

//   // Error states
//   const [locationError, setLocationError] = useState('');
//   const [propertyTypeError, setPropertyTypeError] = useState('');
//   const [categoryError, setCategoryError] = useState('');

//   // Calculate completion percentage
//   const calculateProgress = () => {
//     let filledFields = 0;
//     const totalFields = 3;

//     if (propertyType) filledFields++;
//     if (category) filledFields++;
//     if (location) filledFields++;

//     return Math.round((filledFields / totalFields) * 100);
//   };

//   const progress = calculateProgress();

//   // Save to localStorage
//   useEffect(() => {
//     if (location) localStorage.setItem('propertyLocation', location);
//   }, [location]);

//   useEffect(() => {
//     if (propertyType) localStorage.setItem('propertyType', propertyType);
//   }, [propertyType]);

//   useEffect(() => {
//     if (category) localStorage.setItem('category', category);
//   }, [category]);

//   // ✅ Check if user is returning to flow - ONLY ONCE on component mount
//   useEffect(() => {
//     const hasExistingData = 
//       localStorage.getItem('propertyDetailsFormState') ||
//       localStorage.getItem('propertyImagePreviews') ||
//       localStorage.getItem('amenities_society') ||
//       localStorage.getItem('price_askingPrice') ||
//       localStorage.getItem('rent_monthlyRent');
    
//     if (hasExistingData) {
//       setContinueDialog(true);
//     }
//   }, []); // ✅ Empty dependency array - runs only once

//   // ✅ Handle continue dialog response
//   const handleContinueYes = () => {
//     setContinueDialog(false);
//     // Data is already in localStorage, just continue
//   };

//   const handleContinueNo = () => {
//     // Clear all stored data
//     clearAllPropertyFormData();
    
//     // Reset form
//     setPropertyType('');
//     setCategory('');
//     setLocation('');
//     setContinueDialog(false);
//   };

//   // ✅ Helper function to clear all property form data
//   const clearAllPropertyFormData = () => {
//     // Clear AddNewProperty data
//     localStorage.removeItem('propertyType');
//     localStorage.removeItem('category');
//     localStorage.removeItem('propertyLocation');
    
//     // Clear PropertyDetails data
//     localStorage.removeItem('propertyDetailsFormState');
    
//     // Clear Amenities data
//     localStorage.removeItem('amenities_society');
//     localStorage.removeItem('amenities_furnishing');
//     localStorage.removeItem('amenities_other');
    
//     // Clear PriceDetails data
//     localStorage.removeItem('price_askingPrice');
//     localStorage.removeItem('price_currency');
//     localStorage.removeItem('price_constructionStatus');
//     localStorage.removeItem('price_negotiable');
    
//     // Clear RentDetails data
//     localStorage.removeItem('rent_monthlyRent');
//     localStorage.removeItem('rent_currency');
//     localStorage.removeItem('rent_availableFrom');
//     localStorage.removeItem('rent_securityDeposit');
    
//     // Clear images
//     localStorage.removeItem('propertyImagePreviews');
//   };

//   // Fetch city suggestions
//   const fetchCitySuggestions = async (query) => {
//     if (!query || query.trim().length < 1) {
//       setCitySuggestions([]);
//       setShowSuggestions(false);
//       return;
//     }

//     try {
//       const response = await fetch(
//         `https://propertydealstalk.com/api/property/cities?q=${encodeURIComponent(query)}`
//       );
//       const data = await response.json();

//       if (data.success && data.data && data.data.length > 0) {
//         setCitySuggestions(data.data);
//         setShowSuggestions(true);
//       } else {
//         setCitySuggestions([]);
//         setShowSuggestions(false);
//       }
//     } catch (error) {
//       console.error('Error fetching city suggestions:', error);
//       setCitySuggestions([]);
//       setShowSuggestions(false);
//     }
//   };

//   const handleLocationChange = (e) => {
//     const value = e.target.value;
//     setLocation(value);
//     setAnchorEl(e.currentTarget);

//     // Validation
//     if (!value || value.trim() === '') {
//       setLocationError('Location is required');
//     } else if (value.trim().length < 3) {
//       setLocationError('Location must be at least 3 characters');
//     } else {
//       setLocationError('');
//     }

//     // Debouncing
//     if (debounceTimer) {
//       clearTimeout(debounceTimer);
//     }

//     const newTimer = setTimeout(() => {
//       if (value.trim().length >= 1) {
//         fetchCitySuggestions(value.trim());
//       } else {
//         setCitySuggestions([]);
//         setShowSuggestions(false);
//       }
//     }, 300);

//     setDebounceTimer(newTimer);
//   };

//   const handleSelectCity = (city) => {
//     const cityName = city.name;
//     setLocation(cityName);
//     setShowSuggestions(false);
//     setLocationError('');
//     localStorage.setItem('propertyLocation', cityName);
//   };

//   const handleClickAway = () => {
//     setShowSuggestions(false);
//   };

//   const handleNext = () => {
//     // Validation
//     let hasError = false;

//     if (!propertyType || propertyType.trim() === '') {
//       setPropertyTypeError('Property Type is required');
//       hasError = true;
//     } else {
//       setPropertyTypeError('');
//     }

//     if (!category || category.trim() === '') {
//       setCategoryError('Category is required');
//       hasError = true;
//     } else {
//       setCategoryError('');
//     }

//     if (!location || location.trim() === '') {
//       setLocationError('Location is required');
//       hasError = true;
//     } else {
//       setLocationError('');
//     }

//     if (hasError) return;

//     // ✅ Check if there's existing data in the flow
//     const hasExistingData = localStorage.getItem('propertyDetailsFormState') || 
//                             localStorage.getItem('propertyImagePreviews');

//     // Navigate to next screen
//     const basicDetails = {
//       propertyType: propertyType.trim(),
//       category: category.trim(),
//       location: location.trim(),
//       property_type: propertyType.toLowerCase().trim(),
//       category_value: category.toLowerCase().trim(),
//       city: location.trim(),
//       freshEntry: !hasExistingData,
//       preserveImages: true,
//       timestamp: Date.now(),
//     };

//     navigate('/property-details', { state: basicDetails });
//   };

//   return (
//     <PostAccess
//       currentStep={0}
//       category={category}
//       propertyType={propertyType}
//       assetType=""
//     >
//       {/* ✅ Continue Dialog - ONLY in AddNewProperty */}
//       <Dialog
//         open={continueDialog}
//         onClose={() => {}}
//         aria-labelledby="continue-dialog-title"
//       >
//         <DialogTitle id="continue-dialog-title">
//           Continue where you left off?
//         </DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             You have unsaved property details. Would you like to continue from where you left off?
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleContinueNo} color="secondary">
//             Start Fresh
//           </Button>
//           <Button onClick={handleContinueYes} color="primary" variant="contained" autoFocus>
//             Continue
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Main Content Area */}
//       <Paper
//         elevation={0}
//         sx={{
//           flex: 1,
//           maxWidth: { xs: '100%', md: '700px' },
//           p: { xs: 2.5, sm: 3, md: 3.5 },
//           backgroundColor: '#ffffff',
//           borderRadius: 2,
//           border: '1px solid #e0e0e0',
//         }}
//       >
//         <Typography
//           variant="h5"
//           sx={{
//             fontFamily: 'Outfit',
//             fontWeight: 600,
//             mb: 0.5,
//             fontSize: { xs: '18px', md: '22px' },
//           }}
//         >
//           Add Basic Details
//         </Typography>

//         <Typography
//           sx={{
//             fontFamily: 'Outfit',
//             fontSize: '13px',
//             color: '#666',
//             mb: 3,
//           }}
//         >
//           {progress}% <span style={{ color: '#4caf50' }}>●●○○○</span>
//         </Typography>

//         {/* Form Fields */}
//         <Box
//           sx={{
//             display: 'grid',
//             gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' },
//             gap: { xs: 2, sm: 2.5 },
//           }}
//         >
//           {/* Property Type */}
//           <FormControl fullWidth error={!!propertyTypeError}>
//             <Typography
//               sx={{
//                 fontFamily: 'Outfit',
//                 fontSize: '13px',
//                 fontWeight: 500,
//                 mb: 0.8,
//               }}
//             >
//               Select Property <span style={{ color: '#d32f2f' }}>*</span>
//             </Typography>
//             <Select
//               value={propertyType}
//               onChange={(e) => {
//                 setPropertyType(e.target.value);
//                 setPropertyTypeError('');
//               }}
//               displayEmpty
//               size="small"
//               sx={{
//                 borderRadius: 1.5,
//                 fontFamily: 'Outfit',
//                 fontSize: '13px',
//                 '& .MuiSelect-select': {
//                   py: 1.2,
//                 },
//               }}
//             >
//               <MenuItem value="" disabled>
//                 <em>Select Property</em>
//               </MenuItem>
//               <MenuItem value="Residential">Residential</MenuItem>
//               <MenuItem value="Commercial">Commercial</MenuItem>
//             </Select>
//             {propertyTypeError && (
//               <FormHelperText sx={{ fontSize: '11px' }}>{propertyTypeError}</FormHelperText>
//             )}
//           </FormControl>

//           {/* Category */}
//           <FormControl fullWidth error={!!categoryError}>
//             <Typography
//               sx={{
//                 fontFamily: 'Outfit',
//                 fontSize: '13px',
//                 fontWeight: 500,
//                 mb: 0.8,
//               }}
//             >
//               Select Category <span style={{ color: '#d32f2f' }}>*</span>
//             </Typography>
//             <Select
//               value={category}
//               onChange={(e) => {
//                 setCategory(e.target.value);
//                 setCategoryError('');
//               }}
//               displayEmpty
//               size="small"
//               sx={{
//                 borderRadius: 1.5,
//                 fontFamily: 'Outfit',
//                 fontSize: '13px',
//                 '& .MuiSelect-select': {
//                   py: 1.2,
//                 },
//               }}
//             >
//               <MenuItem value="" disabled>
//                 <em>Select Category</em>
//               </MenuItem>
//               <MenuItem value="Sell">Sell</MenuItem>
//               <MenuItem value="Rent">Rent</MenuItem>
//             </Select>
//             {categoryError && (
//               <FormHelperText sx={{ fontSize: '11px' }}>{categoryError}</FormHelperText>
//             )}
//           </FormControl>

//           {/* Location */}
//           <Box sx={{ gridColumn: { xs: '1', sm: '1' } }}>
//             <Typography
//               sx={{
//                 fontFamily: 'Outfit',
//                 fontSize: '13px',
//                 fontWeight: 500,
//                 mb: 0.8,
//                 mt: { xs: 0, sm: 2.5 },
//               }}
//             >
//               Enter City <span style={{ color: '#d32f2f' }}>*</span>
//             </Typography>

//             <ClickAwayListener onClickAway={handleClickAway}>
//               <Box sx={{ position: 'relative' }}>
//                 <TextField
//                   fullWidth
//                   placeholder="Enter Location"
//                   value={location}
//                   onChange={handleLocationChange}
//                   error={!!locationError}
//                   helperText={locationError}
//                   size="small"
//                   sx={{
//                     '& .MuiOutlinedInput-root': {
//                       borderRadius: 1.5,
//                       fontFamily: 'Outfit',
//                       fontSize: '13px',
//                     },
//                     '& .MuiInputBase-input': {
//                       py: 1.2,
//                     },
//                     '& .MuiFormHelperText-root': {
//                       fontSize: '11px',
//                     },
//                   }}
//                 />

//                 {showSuggestions && citySuggestions.length > 0 && (
//                   <Popper
//                     open={showSuggestions}
//                     anchorEl={anchorEl}
//                     placement="bottom-start"
//                     transition
//                     style={{
//                       width: anchorEl ? anchorEl.clientWidth : 'auto',
//                       zIndex: 1300,
//                     }}
//                   >
//                     {({ TransitionProps }) => (
//                       <Grow {...TransitionProps} timeout={200}>
//                         <Paper
//                           elevation={3}
//                           sx={{
//                             maxHeight: 200,
//                             overflow: 'auto',
//                             mt: 0.5,
//                             border: '1px solid #e0e0e0',
//                             borderRadius: 1,
//                           }}
//                         >
//                           <List dense>
//                             {citySuggestions.map((city, index) => (
//                               <ListItem
//                                 key={`city-${city.id}-${index}`}
//                                 button
//                                 onClick={() => handleSelectCity(city)}
//                                 sx={{
//                                   py: 0.8,
//                                   '&:hover': {
//                                     backgroundColor: '#f5f5f5',
//                                   },
//                                 }}
//                               >
//                                 <ListItemText
//                                   primary={city.name}
//                                   secondary={city.state_name || city.state}
//                                   primaryTypographyProps={{
//                                     fontFamily: 'Outfit',
//                                     fontWeight: 500,
//                                     fontSize: '13px',
//                                   }}
//                                   secondaryTypographyProps={{
//                                     fontFamily: 'Outfit',
//                                     fontSize: '11px',
//                                   }}
//                                 />
//                               </ListItem>
//                             ))}
//                           </List>
//                         </Paper>
//                       </Grow>
//                     )}
//                   </Popper>
//                 )}
//               </Box>
//             </ClickAwayListener>
//           </Box>
//         </Box>

//         {/* Action Buttons */}
//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             gap: 2,
//             mt: 4,
//           }}
//         >
//           <Button
//             variant="outlined"
//             sx={{
//               px: 3,
//               py: 1,
//               borderRadius: 1.5,
//               textTransform: 'none',
//               fontFamily: 'Outfit',
//               fontSize: '13px',
//               color: '#666',
//               borderColor: '#e0e0e0',
//               minWidth: { xs: '80px', sm: '100px' },
//             }}
//           >
//             Back
//           </Button>

//           <Button
//             variant="contained"
//             onClick={handleNext}
//             sx={{
//               px: 3,
//               py: 1,
//               borderRadius: 1.5,
//               textTransform: 'none',
//               fontFamily: 'Outfit',
//               fontSize: '13px',
//               backgroundColor: '#1976d2',
//               minWidth: { xs: '80px', sm: '100px' },
//               '&:hover': {
//                 backgroundColor: '#1565c0',
//               },
//             }}
//           >
//             Next
//           </Button>
//         </Box>
//       </Paper>
//     </PostAccess>
//   );
// };

// export default AddNewProperty;


import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  TextField,
  Container,
  Paper,
  useMediaQuery,
  useTheme,
  FormHelperText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Divider,
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import PostAccess from './PostAccess';

const AddNewProperty = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // State management
  const [propertyType, setPropertyType] = useState(() => {
    return localStorage.getItem('propertyType') || '';
  });

  const [category, setCategory] = useState(() => {
    return localStorage.getItem('category') || '';
  });

  const [location, setLocation] = useState(() => {
    return localStorage.getItem('propertyLocation') || '';
  });

  // Continue dialog state
  const [continueDialog, setContinueDialog] = useState(false);

  // City suggestions
  const [citySuggestions, setCitySuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [showPopularCities, setShowPopularCities] = useState(false);
  const [debounceTimer, setDebounceTimer] = useState(null);

  // Error states
  const [locationError, setLocationError] = useState('');
  const [propertyTypeError, setPropertyTypeError] = useState('');
  const [categoryError, setCategoryError] = useState('');

  // Top and Other Cities
  const topCities = [
    { name: 'Hyderabad', state: 'Telangana' },
    { name: 'Vijayawada', state: 'Andhra Pradesh' },
    { name: 'Visakhapatnam', state: 'Andhra Pradesh' },
  ];

  const otherCities = [
    { name: 'Guntur', state: 'Andhra Pradesh' },
    { name: 'Nellore', state: 'Andhra Pradesh' },
    { name: 'Kurnool', state: 'Andhra Pradesh' },
    { name: 'Rajahmundry', state: 'Andhra Pradesh' },
    { name: 'Tirupati', state: 'Andhra Pradesh' },
    { name: 'Kakinada', state: 'Andhra Pradesh' },
    { name: 'Warangal', state: 'Telangana' },
    { name: 'Nizamabad', state: 'Telangana' },
    { name: 'Karimnagar', state: 'Telangana' },
    { name: 'Khammam', state: 'Telangana' },
  ];

  // Calculate completion percentage
  const calculateProgress = () => {
    let filledFields = 0;
    const totalFields = 3;

    if (propertyType) filledFields++;
    if (category) filledFields++;
    if (location) filledFields++;

    return Math.round((filledFields / totalFields) * 100);
  };

  const progress = calculateProgress();

  // Save to localStorage
  useEffect(() => {
    if (location) localStorage.setItem('propertyLocation', location);
  }, [location]);

  useEffect(() => {
    if (propertyType) localStorage.setItem('propertyType', propertyType);
  }, [propertyType]);

  useEffect(() => {
    if (category) localStorage.setItem('category', category);
  }, [category]);

  // Check if user is returning to flow
  useEffect(() => {
    const hasExistingData = 
      localStorage.getItem('propertyDetailsFormState') ||
      localStorage.getItem('propertyImagePreviews') ||
      localStorage.getItem('amenities_society') ||
      localStorage.getItem('price_askingPrice') ||
      localStorage.getItem('rent_monthlyRent');
    
    if (hasExistingData) {
      setContinueDialog(true);
    }
  }, []);

  // Handle continue dialog response
  const handleContinueYes = () => {
    setContinueDialog(false);
  };

  const handleContinueNo = () => {
    clearAllPropertyFormData();
    setPropertyType('');
    setCategory('');
    setLocation('');
    setContinueDialog(false);
  };

  // Helper function to clear all property form data
  const clearAllPropertyFormData = () => {
    localStorage.removeItem('propertyType');
    localStorage.removeItem('category');
    localStorage.removeItem('propertyLocation');
    localStorage.removeItem('propertyDetailsFormState');
    localStorage.removeItem('amenities_society');
    localStorage.removeItem('amenities_furnishing');
    localStorage.removeItem('amenities_other');
    localStorage.removeItem('price_askingPrice');
    localStorage.removeItem('price_currency');
    localStorage.removeItem('price_constructionStatus');
    localStorage.removeItem('price_negotiable');
    localStorage.removeItem('rent_monthlyRent');
    localStorage.removeItem('rent_currency');
    localStorage.removeItem('rent_availableFrom');
    localStorage.removeItem('rent_securityDeposit');
    localStorage.removeItem('propertyImagePreviews');
  };

  // Fetch city suggestions
  const fetchCitySuggestions = async (query) => {
    if (!query || query.trim().length < 1) {
      setCitySuggestions([]);
      setShowSuggestions(false);
      setShowPopularCities(false);
      return;
    }

    try {
      const response = await fetch(
        `https://propertydealstalk.com/api/property/cities?q=${encodeURIComponent(query)}`
      );
      const data = await response.json();

      if (data.success && data.data && data.data.length > 0) {
        setCitySuggestions(data.data);
        setShowSuggestions(true);
        setShowPopularCities(false);
      } else {
        setCitySuggestions([]);
        setShowSuggestions(false);
      }
    } catch (error) {
      console.error('Error fetching city suggestions:', error);
      setCitySuggestions([]);
      setShowSuggestions(false);
    }
  };

  const handleLocationChange = (e) => {
    const value = e.target.value;
    setLocation(value);

    // Validation
    if (!value || value.trim() === '') {
      setLocationError('Location is required');
    } else if (value.trim().length < 3) {
      setLocationError('Location must be at least 3 characters');
    } else {
      setLocationError('');
    }

    // Debouncing
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }

    const newTimer = setTimeout(() => {
      if (value.trim().length >= 1) {
        fetchCitySuggestions(value.trim());
      } else {
        setCitySuggestions([]);
        setShowSuggestions(false);
        setShowPopularCities(false);
      }
    }, 300);

    setDebounceTimer(newTimer);
  };

  const handleCitySelect = (cityName) => {
    setLocation(cityName);
    setShowSuggestions(false);
    setShowPopularCities(false);
    setLocationError('');
    localStorage.setItem('propertyLocation', cityName);
  };

  const handleBack = () => {
    navigate('/sell-properties');
  };

  const handleNext = () => {
    let hasError = false;

    if (!propertyType || propertyType.trim() === '') {
      setPropertyTypeError('Property Type is required');
      hasError = true;
    } else {
      setPropertyTypeError('');
    }

    if (!category || category.trim() === '') {
      setCategoryError('Category is required');
      hasError = true;
    } else {
      setCategoryError('');
    }

    if (!location || location.trim() === '') {
      setLocationError('Location is required');
      hasError = true;
    } else {
      setLocationError('');
    }

    if (hasError) return;

    const hasExistingData = localStorage.getItem('propertyDetailsFormState') || 
                            localStorage.getItem('propertyImagePreviews');

    const basicDetails = {
      propertyType: propertyType.trim(),
      category: category.trim(),
      location: location.trim(),
      property_type: propertyType.toLowerCase().trim(),
      category_value: category.toLowerCase().trim(),
      city: location.trim(),
      freshEntry: !hasExistingData,
      preserveImages: true,
      timestamp: Date.now(),
    };

    navigate('/property-details', { state: basicDetails });
  };

  return (
    <PostAccess
      currentStep={0}
      category={category}
      propertyType={propertyType}
      assetType=""
    >
      {/* Continue Dialog */}
      <Dialog
        open={continueDialog}
        onClose={() => {}}
        aria-labelledby="continue-dialog-title"
      >
        <DialogTitle id="continue-dialog-title">
          Continue where you left off?
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            You have unsaved property details. Would you like to continue from where you left off?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleContinueNo} color="secondary">
            Start Fresh
          </Button>
          <Button onClick={handleContinueYes} color="primary" variant="contained" autoFocus>
            Continue
          </Button>
        </DialogActions>
      </Dialog>

      {/* Main Content Area */}
      <Paper
        elevation={0}
        sx={{
          flex: 1,
          maxWidth: { xs: '100%', md: '700px' },
          p: { xs: 2.5, sm: 3, md: 3.5 },
          backgroundColor: '#ffffff',
          borderRadius: 2,
          border: '1px solid #e0e0e0',
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontFamily: 'Outfit',
            fontWeight: 600,
            mb: 0.5,
            fontSize: { xs: '18px', md: '22px' },
          }}
        >
          Add Basic Details
        </Typography>

        <Typography
          sx={{
            fontFamily: 'Outfit',
            fontSize: '13px',
            color: '#666',
            mb: 3,
          }}
        >
          {progress}% <span style={{ color: '#4caf50' }}>●●○○○</span>
        </Typography>

        {/* Form Fields */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
          }}
        >
          {/* Property Type */}
          <Box>
            <Typography
              sx={{
                fontFamily: 'Outfit',
                fontSize: '13px',
                fontWeight: 500,
                mb: 1.5,
              }}
            >
              Property Type <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <Box
              sx={{
                display: 'flex',
                gap: 1.5,
                flexDirection: { xs: 'column', sm: 'row' },
              }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  setPropertyType('Residential');
                  setPropertyTypeError('');
                }}
                sx={{
                  width: '200px',
                  py: 1.5,
                  borderRadius: 2,
                  textTransform: 'none',
                  fontFamily: 'Outfit',
                  fontSize: '15px',
                  fontWeight: 500,
                  color: propertyType === 'Residential' ? '#6C5CE7' : '#000',
                  backgroundColor: propertyType === 'Residential' ? '#EEEAFF' : '#fff',
                  borderColor: propertyType === 'Residential' ? '#6C5CE7' : '#e0e0e0',
                  '&:hover': {
                    backgroundColor: propertyType === 'Residential' ? '#EEEAFF' : '#f5f5f5',
                    borderColor: '#6C5CE7',
                  },
                }}
              >
                Residential
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  setPropertyType('Commercial');
                  setPropertyTypeError('');
                }}
                sx={{
                  width: '200px',
                  py: 1.5,
                  borderRadius: 2,
                  textTransform: 'none',
                  fontFamily: 'Outfit',
                  fontSize: '15px',
                  fontWeight: 500,
                  color: propertyType === 'Commercial' ? '#000' : '#000',
                  backgroundColor: propertyType === 'Commercial' ? '#EEEAFF' : '#fff',
                  borderColor: propertyType === 'Commercial' ? '#000' : '#e0e0e0',
                  '&:hover': {
                    backgroundColor: propertyType === 'Commercial' ? '#EEEAFF' : '#f5f5f5',
                    borderColor: '#000',
                  },
                }}
              >
                Commercial
              </Button>
            </Box>
            {propertyTypeError && (
              <FormHelperText error sx={{ fontSize: '11px', mt: 0.5 }}>
                {propertyTypeError}
              </FormHelperText>
            )}
          </Box>

          {/* Category */}
          <Box>
            <Typography
              sx={{
                fontFamily: 'Outfit',
                fontSize: '13px',
                fontWeight: 500,
                mb: 1.5,
              }}
            >
              Category <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <Box
              sx={{
                display: 'flex',
                gap: 1.5,
                flexDirection: { xs: 'column', sm: 'row' },
              }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  setCategory('Sell');
                  setCategoryError('');
                }}
                sx={{
                  width: '200px',
                  py: 1.5,
                  borderRadius: 2,
                  textTransform: 'none',
                  fontFamily: 'Outfit',
                  fontSize: '15px',
                  fontWeight: 500,
                  color: category === 'Sell' ? '#6C5CE7' : '#000',
                  backgroundColor: category === 'Sell' ? '#EEEAFF' : '#fff',
                  borderColor: category === 'Sell' ? '#6C5CE7' : '#e0e0e0',
                  '&:hover': {
                    backgroundColor: category === 'Sell' ? '#EEEAFF' : '#f5f5f5',
                    borderColor: '#6C5CE7',
                  },
                }}
              >
                Sell
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  setCategory('Rent');
                  setCategoryError('');
                }}
                sx={{
                  width: '200px',
                  py: 1.5,
                  borderRadius: 2,
                  textTransform: 'none',
                  fontFamily: 'Outfit',
                  fontSize: '15px',
                  fontWeight: 500,
                  color: category === 'Rent' ? '#000' : '#000',
                  backgroundColor: category === 'Rent' ? '#EEEAFF' : '#fff',
                  borderColor: category === 'Rent' ? '#000' : '#e0e0e0',
                  '&:hover': {
                    backgroundColor: category === 'Rent' ? '#EEEAFF' : '#f5f5f5',
                    borderColor: '#000',
                  },
                }}
              >
                Rent
              </Button>
            </Box>
            {categoryError && (
              <FormHelperText error sx={{ fontSize: '11px', mt: 0.5 }}>
                {categoryError}
              </FormHelperText>
            )}
          </Box>

          {/* Location with Top Cities & Other Cities */}
          <Box>
            <Typography
              sx={{
                fontFamily: 'Outfit',
                fontSize: '13px',
                fontWeight: 500,
                mb: 0.8,
              }}
            >
              Location <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>

            <Box sx={{ position: 'relative', maxWidth: { xs: '100%', sm: '400px' } }}>
              <TextField
                fullWidth
                placeholder="Search Location"
                value={location}
                onChange={handleLocationChange}
                onBlur={() => {
                  setTimeout(() => {
                    setShowSuggestions(false);
                    setShowPopularCities(false);
                  }, 200);
                }}
                onFocus={() => {
                  if (location.trim().length === 0) {
                    setShowPopularCities(true);
                    setShowSuggestions(false);
                  } else if (location.trim().length >= 1 && citySuggestions.length > 0) {
                    setShowSuggestions(true);
                    setShowPopularCities(false);
                  } else if (location.trim().length >= 1) {
                    fetchCitySuggestions(location.trim());
                  }
                }}
                error={!!locationError}
                helperText={locationError}
                size="small"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 1.5,
                    fontFamily: 'Outfit',
                    fontSize: '13px',
                  },
                  '& .MuiInputBase-input': {
                    py: 1.2,
                  },
                  '& .MuiFormHelperText-root': {
                    fontSize: '11px',
                  },
                }}
              />

              {/* Popular Cities Dropdown */}
              {showPopularCities && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: '40px',
                    left: 0,
                    right: 0,
                    zIndex: 10,
                    maxHeight: '350px',
                    overflowY: 'auto',
                    backgroundColor: '#fff',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    borderRadius: '4px',
                    mt: '4px',
                    border: '1px solid #e0e0e0',
                  }}
                >
                  {/* Top Cities Section */}
                  <Box sx={{ padding: '12px 16px', backgroundColor: '#f8f9fa' }}>
                    <Typography sx={{ fontWeight: 600, fontSize: '13px', color: '#666', textTransform: 'uppercase' }}>
                      Top Cities
                    </Typography>
                  </Box>
                  {topCities.map((cityItem, index) => (
                    <Box
                      key={`top-city-${index}`}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '12px 16px',
                        cursor: 'pointer',
                        borderBottom: '1px solid #f0f0f0',
                        '&:hover': {
                          backgroundColor: '#f5f5f5',
                        },
                        fontFamily: 'Outfit',
                      }}
                      onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleCitySelect(cityItem.name);
                      }}
                    >
                      <LocationCityIcon sx={{ color: '#0052ff', fontSize: '20px', mr: 1.5 }} />
                      <Box>
                        <Typography sx={{ fontWeight: 500, fontSize: '14px', color: '#333' }}>
                          {cityItem.name}
                        </Typography>
                        <Typography sx={{ fontSize: '12px', color: '#999' }}>
                          {cityItem.state}
                        </Typography>
                      </Box>
                    </Box>
                  ))}

                  <Divider sx={{ my: 1 }} />

                  {/* Other Cities Section */}
                  <Box sx={{ padding: '12px 16px', backgroundColor: '#f8f9fa' }}>
                    <Typography sx={{ fontWeight: 600, fontSize: '13px', color: '#666', textTransform: 'uppercase' }}>
                      Other Cities
                    </Typography>
                  </Box>
                  {otherCities.map((cityItem, index) => (
                    <Box
                      key={`other-city-${index}`}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '12px 16px',
                        cursor: 'pointer',
                        borderBottom: index < otherCities.length - 1 ? '1px solid #f0f0f0' : 'none',
                        '&:hover': {
                          backgroundColor: '#f5f5f5',
                        },
                        fontFamily: 'Outfit',
                      }}
                      onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleCitySelect(cityItem.name);
                      }}
                    >
                      <LocationOnIcon sx={{ color: '#666', fontSize: '20px', mr: 1.5 }} />
                      <Box>
                        <Typography sx={{ fontWeight: 500, fontSize: '14px', color: '#333' }}>
                          {cityItem.name}
                        </Typography>
                        <Typography sx={{ fontSize: '12px', color: '#999' }}>
                          {cityItem.state}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
                </Box>
              )}

              {/* Search Suggestions Dropdown */}
              {showSuggestions && citySuggestions.length > 0 && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: '40px',
                    left: 0,
                    right: 0,
                    zIndex: 10,
                    maxHeight: '200px',
                    overflowY: 'auto',
                    backgroundColor: '#fff',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                    borderRadius: '4px',
                    mt: '4px',
                    border: '1px solid #e0e0e0',
                  }}
                >
                  {citySuggestions.map((suggestion, index) => (
                    <Box
                      key={`city-${suggestion.id}-${index}`}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '10px 12px',
                        cursor: 'pointer',
                        borderBottom: index < citySuggestions.length - 1 ? '1px solid #f0f0f0' : 'none',
                        '&:hover': {
                          backgroundColor: '#f5f5f5',
                        },
                        fontFamily: 'Outfit',
                      }}
                      onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleCitySelect(suggestion.name);
                      }}
                    >
                      <LocationOnIcon sx={{ color: '#666', fontSize: '20px', mr: 1.5 }} />
                      <Box>
                        <Typography sx={{ fontWeight: 900, fontSize: '14px', color: '#333' }}>
                          {suggestion.name}
                        </Typography>
                        {suggestion.state_name && (
                          <Typography sx={{ fontWeight: 500, fontSize: '12px', color: '#999' }}>
                            {suggestion.state_name}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  ))}
                </Box>
              )}
            </Box>
          </Box>
        </Box>

        {/* Action Buttons */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 2,
            mt: 4,
          }}
        >
          <Button
            variant="outlined"
            onClick={handleBack}
            sx={{
              px: 3,
              py: 1,
              borderRadius: 1.5,
              textTransform: 'none',
              fontFamily: 'Outfit',
              fontSize: '13px',
              color: '#666',
              borderColor: '#e0e0e0',
              minWidth: { xs: '80px', sm: '100px' },
              '&:hover': {
                borderColor: '#999',
                backgroundColor: '#f5f5f5',
              },
            }}
          >
            Back
          </Button>

          <Button
            variant="contained"
            onClick={handleNext}
            sx={{
              px: 3,
              py: 1,
              borderRadius: 1.5,
              textTransform: 'none',
              fontFamily: 'Outfit',
              fontSize: '13px',
              backgroundColor: '#1976d2',
              minWidth: { xs: '80px', sm: '100px' },
              '&:hover': {
                backgroundColor: '#1565c0',
              },
            }}
          >
            Next
          </Button>
        </Box>
      </Paper>
    </PostAccess>
  );
};

export default AddNewProperty;
